module.exports = __webpack_public_path__ + "img/img2.07c81c37.png";